var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "total-item", class: [_vm.breakpointClass, _vm.item.alias] },
    [
      _c("span", { class: [_vm.getIcon(_vm.item.alias), "total-icon"] }),
      _c("div", { staticClass: "total-data-container" }, [
        _c("div", { staticClass: "total-title" }, [
          _vm._v(_vm._s(_vm.item.detail)),
        ]),
        _c("div", { staticClass: "total-quantity" }, [
          _vm._v(_vm._s(_vm.item[_vm.fieldTotalName])),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }